module.exports = {"id":"225926","name":"Pere Milla","rating":"71","photo":"./data/images/photos/3/225926.png","club":{"name":"CD Numancia","logo":"./data/images/clubs/CDNumancia.png"},"positions":["MD","MG","MOC","BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PereMilla0.json
// module id = 3435
// module chunks = 0